export const businessData = {
  title: "Your organization's reputation is invaluable; What steps are you taking to protect it?",
  subtitle: "Social media management for your business or organization",
  sectionOneTitle: "Why do Businesses use Redact?",
  sectionOneSubtitle:
    "The only service that enables your organization to privately and securely automate content deletion from platforms like Twitter, Instagram, Facebook, Discord, and more - all in one place",
  grid: [
    {
      icon: "photos",
      text: "Delete your posts, comments, likes, DMs and more! Across all major platforms.",
    },
    { icon: "squares", text: "30+ Major social media & direct messaging platforms supported." },

    {
      icon: "paper",
      text: "Old social media posts are an attack vector for bad actors to target and gather information on your employees.",
    },
    { icon: "news", text: "Avoid unwanted headlines due to posting mishaps." },
    { icon: "trash", text: "Manage your organization's social media accounts with ease." },
    {
      icon: "lightbulb",
      text: "Protect sensitive information leaks by using automatic keyword deletion.",
    },
    {
      icon: "umbrella",
      text: "Take proactive steps to mitigate online harassment, bullying, and brigading of your organization social media pages.",
    },
    {
      icon: "law",
      text: "Prevent retroactive copyright lawsuits with automatic content deletion.",
    },
  ],
  stepsTitle: "How does Redact Pro work?",
  stepsSubtitle: "EASY STEPS TO GET STARTED",
  steps: [
    {
      image: "/images/business/01.svg",
      number: "1",
      title: "List all social accounts",
      text: "Gather the logins of accounts you want to moderate and issue licenses to team members.",
    },
    {
      image: "/images/business/02.svg",
      number: "2",
      title: "Download Redact Pro App",
      text: "Get the Redact Pro App to get started.",
    },
    {
      image: "/images/business/03.svg",
      number: "3",
      title: "Connect all social accounts",
      text: "Connect the accounts with the Redact Pro app, across any of supported platform.",
    },
    {
      image: "/images/business/04.svg",
      number: "4",
      title: "Deletion method",
      text: "Choose from a series of review and deletion methods.",
    },
    {
      image: "/images/business/05.svg",
      number: "5",
      title: "Presets and automation",
      text: "Save deletion form presets & schedule automated deletion.",
    },
  ],

  bottomText:
    "Request a demo or consultation, and let us know the scope of your plan! We want to hear from you.",
};
